// src/components/accounts/AccountTabs.jsx
import React from 'react';
import { User, BriefcaseBusiness, Notebook, ChevronDown, ReceiptText, FileText } from 'lucide-react';

const tabs = [
  { id: 'general', name: 'Genel Bilgiler', icon: User },
  { id: 'ledger', name: 'Hesap Ekstresi', icon: ReceiptText },
  { id: 'invoices', name: 'Faturalar', icon: ReceiptText },
  { id: 'operations', name: 'Operasyonlar', icon: BriefcaseBusiness },
  { id: 'notes', name: 'Özel Notlar', icon: Notebook },
  { id: 'documents', name: 'Müşteri Evrakları', icon: FileText },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const AccountTabs = ({ activeTab, setActiveTab, isNew = false, compact = false }) => {
  const visibleTabs = isNew
    ? tabs.filter((tab) => tab.id === 'general')
    : tabs;

  return (
    <div className={classNames(
      'bg-white border border-slate-100 shadow-sm',
      compact ? 'rounded-2xl p-1.5' : 'rounded-3xl p-2'
    )}>
      {/* Mobile: Select Menu */}
      <div className="sm:hidden relative">
        <select
          value={activeTab}
          onChange={(e) => setActiveTab(e.target.value)}
          className={classNames(
            'w-full appearance-none border-none outline-none ring-1 ring-slate-200',
            compact
              ? 'rounded-xl bg-slate-50 py-2.5 pl-4 pr-10 text-xs font-bold text-slate-700'
              : 'rounded-xl bg-slate-50 py-3 pl-4 pr-10 text-sm font-bold text-slate-700'
          )}
        >
          {visibleTabs.map((tab) => (
            <option key={tab.id} value={tab.id}>
              {tab.name}
            </option>
          ))}
        </select>
        <ChevronDown className={classNames(
          'pointer-events-none absolute right-3 text-slate-400',
          compact ? 'top-3 size-4' : 'top-3.5 size-4'
        )} />
      </div>

      {/* Desktop: Navigation Tabs */}
      <nav className={classNames('hidden sm:flex gap-2', compact ? 'flex-wrap' : '')}>
        {visibleTabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={classNames(
                isActive
                  ? 'bg-slate-900 text-white shadow-md'
                  : 'text-slate-500 hover:bg-slate-50 hover:text-slate-700',
                compact
                  ? 'flex items-center gap-2 rounded-xl px-4 py-2 text-xs font-bold transition-all duration-200'
                  : 'flex items-center gap-2 rounded-xl px-5 py-2.5 text-sm font-bold transition-all duration-200'
              )}
            >
              <Icon size={16} strokeWidth={isActive ? 3 : 2} />
              {tab.name}
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default AccountTabs;
